import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "history-wrapper" }
const _hoisted_2 = { class: "history-row" }
const _hoisted_3 = { class: "history-header" }
const _hoisted_4 = { class: "history-header__title" }
const _hoisted_5 = { class: "h3" }
const _hoisted_6 = { class: "history-header__link-icon" }
const _hoisted_7 = { class: "caption-navbar color-text-primary" }
const _hoisted_8 = { class: "history-body" }
const _hoisted_9 = { class: "history-body__tabs" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "caption-navbar color-grey-light" }

import { ref } from "vue";
import { useI18n } from "vue-i18n";
import HistoryFinances from "@/components/history/HistoryFinances.vue";
import HistoryOperations from "@/components/history/HistoryOperations.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";

interface TabType {
  title: string;
  active: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryPage',
  setup(__props) {

const { t } = useI18n();

const tabs = ref<TabType[]>([
  { title: t("history.page.tabs.finances"), active: true },
  { title: t("history.page.tabs.usage"), active: false },
]);

function toggleTabs(tab: TabType, tabArray: TabType[]) {
  tabArray.forEach((item) => (item.active = false));
  const found = tabArray.find((item) => item === tab);
  if (found) found.active = true;
}

const tabClasses = (active: boolean) => {
  return [active ? "active" : ""];
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "account",
          class: "history-header__back"
        }, {
          default: _withCtx(() => [
            _createVNode(BaseFigureForIcon, {
              size: "medium",
              color: "white",
              icon: "arrow",
              position: "left",
              "is-button": ""
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("history.page.title")), 1)
        ]),
        _createVNode(_component_router_link, {
          to: { name: 'settings', query: { details: true } },
          class: "history-header__link"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(BaseIcon, { name: "details" })
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("history.page.details")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["history-body__tabs-item", tabClasses(tab.active)]),
              onClick: ($event: any) => (toggleTabs(tab, tabs.value))
            }, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(tab.title), 1)
            ], 10, _hoisted_10))
          }), 128))
        ]),
        (tabs.value[0].active)
          ? (_openBlock(), _createBlock(HistoryFinances, { key: 0 }))
          : (_openBlock(), _createBlock(HistoryOperations, { key: 1 }))
      ])
    ])
  ]))
}
}

})